const EDIT_CACHE_KEY = (id: string) => `yh_project_edit_${id}`;

export const cacheProjectForEdit = (id: string, data: any) => {
  if (!id || !data) return;
  try {
    const plain = JSON.parse(JSON.stringify(data));
    sessionStorage.setItem(EDIT_CACHE_KEY(String(id)), JSON.stringify(plain));
  } catch {
    // ignore non-serializable row fields
  }
};

export const readCachedProjectForEdit = (id?: string) => {
  if (!id) return null;
  try {
    const raw = sessionStorage.getItem(EDIT_CACHE_KEY(String(id)));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
